import axios, { AxiosInstance, CancelToken } from 'axios';
import get from 'lodash/get';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { TeamMemberProject } from 'utils/types/dailyTeamsCapacity';

export interface FetchTeamMembersListResponse {
  teamMemberProjects: Omit<TeamMemberProject, 'teamMembersIds'>[];
  links: {
    next: string | null;
  };
}

class TeamMemberProjectsListAPI {
  instance: AxiosInstance;
  constructor() {
    this.instance = initAxios(config.get('backendURL'));
  }

  fetchTeamMemberProjectsList: (
    url: string,
    cancelToken?: CancelToken
  ) => Promise<FetchTeamMembersListResponse> = async (url, cancelToken) => {
    const response = await this.instance.get<FetchTeamMembersListResponse>(
      url,
      {
        cancelToken,
      }
    );
    if (axios.isAxiosError(response)) {
      const errorMessage = get(response, 'response.data.message', '');
      throw errorMessage;
    }
    return response.data;
  };
}

const teamMemberProjectsListAPI = new TeamMemberProjectsListAPI();
export default teamMemberProjectsListAPI;
